<template>
  <div class="feed" :class="{feedHidden : !$route.meta.rootActive}">
    <div class="feed-label">
    	_Things I make just out of curiosity ↘ 
    </div>
    <masonry
	  :cols="{default: 6, 1000: 4, 700: 3, 400: 2}"
	  :gutter="8"
	  >
    <!-- <div>{{filteredPosts}}</div> -->
    <div v-for="content in filteredPosts" :key="content.id">
		<div class="feed-tile" v-if="content.class == 'Image'">
	    	<img :src="content.image.display.url" />
	    </div>
		<div class="feed-tile" v-if="content.class == 'Media'">
	    	<img :src="content.image.display.url" />
	    </div>
    </div>
	</masonry>
  </div>
</template>

<script>
export default {
  name: "Feed",
  data(){
		return {
      	p2017: []
   			}
  	},
		created() {
			this.$Progress.start()
			this.arena.channel('gb-co').get()
			  .then(chan => {
				this.p2017 = chan.contents
				this.$Progress.finish()
				})
			  .catch(err => console.log(err))
			},
		computed: {
		  filteredPosts: function () {
		    return this.p2017.slice().reverse().filter((post) => {
		    	if(post.class != "Channel"){
		    		return post;
		    	}
		    })
		  }
		}	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.feed
	padding .5rem
	padding-top 1rem
	background-color blue
.feedHidden
	display none
.feed-label
	font-size 1rem
	text-align left
	text-transform uppercase
	color #fff
	margin-bottom 1rem
.feed-tile
	img
		max-width 100%
		max-height 100%
		margin 0 auto
</style>
